import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {RouterModule} from '@angular/router';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PlatformToolNewsletterContentComponent} from '@features/newsletter/components/platform-tool-newsletter-content/platform-tool-newsletter-content.component';
import {NewsletterRoutes} from '@features/newsletter/newsletter.routes';
import {NewsletterDynamicComponentHelper} from '@features/newsletter/newsletter-dynamic-component-helper';
import {Api} from '@shared/constants/common-field.constants';
import {SharedModule} from "@shared/shared.module";
import {CoreModule} from "@core/core.module";
import {FuseSharedModule} from "@barebone-fuse/@fuse/shared.module";
import {FuseSearchBarModule} from "@barebone-fuse/@fuse/components";
import {IntlModule} from "@progress/kendo-angular-intl";
import {DateInputsModule} from "@progress/kendo-angular-dateinputs";
import {NewsLetterContentHandler} from '@features/newsletter/services/newsletter-handler';



@NgModule({
  declarations: [
    PlatformToolNewsletterContentComponent
  ],
  imports: [
    RouterModule.forChild(NewsletterRoutes),
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
  callSetDisabledState: 'whenDisabledForLegacyCode',
}),
    SharedModule,
    CoreModule,
    FuseSharedModule,
    FuseSearchBarModule,
    IntlModule,
    DateInputsModule
  ],
  exports: [
    PlatformToolNewsletterContentComponent
  ]
})
export class NewsletterModule {
  constructor(private commandService: CommandService,
              private newsLetterHandler: NewsLetterContentHandler) {
    NewsletterDynamicComponentHelper.init();
    NewsletterDynamicComponentHelper.register('PlatformToolNewsLetterContentHandler', newsLetterHandler);
    const newsletterCommand = new PlatformCommand('NewsletterContentToolLinkCommand', Api.TaxNews);
    this.commandService.registrPlatformLinkCommand('/taxnews/newsletter', newsletterCommand);
  }
}
